import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${(p) => p.$fullHeight && css`min-height: 100vh;`}
  ${(p) => p.$p && responsive('padding', p.$p, p.theme)}
`

export function Center({ children, fullHeight = false, p }) {
  return (
    <Root $fullHeight={fullHeight} $p={p}>
      {children}
    </Root>
  )
}
